import { render } from "./Muziek.vue?vue&type=template&id=e2f7e5e6&scoped=true"
import script from "./Muziek.vue?vue&type=script&lang=js"
export * from "./Muziek.vue?vue&type=script&lang=js"

import "./Muziek.vue?vue&type=style&index=0&id=e2f7e5e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e2f7e5e6"]])

export default __exports__